import React, { useState, useEffect } from "react";
import Title from "../Title/Title";
import Button from "../Button/Button";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./Result.module.scss";
import classNames from "classnames";
import { SITE_URL, GO_URL } from "../../state/consts";
import { IconButton, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";

import { WhatsappShareButton, TelegramShareButton } from "react-share";

import { WhatsappIcon, TelegramIcon } from "react-share";

function Result({
  score,
  title,
  text,
  imageSrc,
  posterContainer,
  optionsContainer,
  handlerBack,
}) {
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ImageURL = SITE_URL + imageSrc;

  const handleClick = (e) => {
    e.preventDefault();
    window.open(GO_URL);
  };

  // кнопка скопировать
  const [open, setOpen] = useState(false);

  const testClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  return (
    <>
      <div className={posterContainer}>
        <img src={imageSrc} className={styles.image} alt="" />
      </div>
      <div className={classNames(optionsContainer, styles.before)}>
        <div
          className={classNames({
            [styles.resultPosterContainer]: true,
            [styles.onScrollOption]: offset,
          })}
        >
          <div className={styles.contentWrapper}>
            <div className={styles.score}>{score}</div>
            <Title value={title} />
            {text}
          </div>
          <div className={styles.buttonBox}>
            <a
              href="https://taximaxim.onelink.me/KKXl?af_xp=custom&pid=grdeep_push&c=grdeep_tariff_ph_group_B&is_retargeting=true&af_reengagement_window=30d&af_dp=maximzakaz%3A%2F%2Fapp%3Faction%3Dtariff%26category%3DTRUCK"
              target="_blank"
              rel="noreferrer"
            >
              <Button value="Go to app" className={styles.buttonPresent} />
            </a>
            <Button
              value="Play again"
              className={styles.outline}
              onClick={handlerBack}
              id="refresh"
            />
          </div>

          <div
            className={classNames(styles.contentWrapper, styles.socialWrapper)}
          >
            <Paragraph value="Share" />
            <div className={styles.social}>
              <WhatsappShareButton
                url={SITE_URL}
                title="I helped Maximka move into a new apartment! Play a game by Maxim and learn how to make your moving as simple as possible."
                image={ImageURL}
                id="whatsapp"
              >
                <WhatsappIcon
                  size={48}
                  round={true}
                  className={classNames(styles.icon, styles.whatsapp)}
                />
              </WhatsappShareButton>

              <TelegramShareButton
                url={SITE_URL}
                title="I helped Maximka move into a new apartment! Play a game by Maxim and learn how to make your moving as simple as possible."
                image={ImageURL}
                id="telegram"
              >
                <TelegramIcon
                  size={48}
                  round={true}
                  className={classNames(styles.icon, styles.telegram)}
                />
              </TelegramShareButton>

              <div id="sharelink">
                <IconButton
                  onClick={testClick}
                  color="primary"
                  className={styles.share}
                >
                  <ShareIcon />
                </IconButton>
                <Snackbar
                  message="Copied to clipboard"
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  autoHideDuration={1000}
                  onClose={() => setOpen(false)}
                  open={open}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Result;
